module.exports = __webpack_public_path__ + "img/02.46e170ab.png";